



























import { Component, Vue, Watch, Prop, Emit, Model } from "vue-property-decorator";
import keepCorner from "@/packages/corner/Corners.vue";

@Component({
  components: {
    keepCorner,
  },
})
export default class Corner extends Vue {
  @Prop({ required: false }) private length!: any;
  // @Prop({ required: false, default: 0 }) private active!: any;
  @Prop({ required: false, default: () => [] }) private list!: any;
  @Model('change') private active!: any;

  private created() {
    // 如果List没有参数传递值，则根据length +
    // 遍历数组长度
    if (!this.list.length) {
      for (let i = 0; i < this.length; i++) {
        this.list.push({
          active: false,
          index: i,
        });
      }
    }
    // 默认选中
    this.list.forEach((el: any, index: number) => {
      if (index === this.active) {
        el.active = true;
      }
    });
  }

  private changeTab(item: any, index: any) {
    this.list.forEach((el: any) => {
      el.active = false;
    });
    item.active = !item.active;
    this.list.splice(index, 1, item);
    this.$emit('change', index);
  }
}
